/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctTimestamp, FctValue } from '../../../../Fct/generics';
import { FaExchangeAlt } from 'react-icons/fa';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../constants';
export var UniswapV2SwapTokensForExactTokens = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'swapTokensForExactTokens',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    amountOut: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaExchangeAlt }),
                    amountInMax: new FctValue({ destination: 'wei_amount' }),
                    path: new FctAddressList({ destination: 'ERC20_List', options: getSupportedTokens({ chainId: chainId }), isPreview: true }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2, innerType: 'uint256[]' }),
                amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1, innerType: 'uint256[]' }),
            },
        });
    },
    supportedContracts: ROUTER_V2_ADDRESSES,
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
    requiredApprovals: function (params) {
        var token = (params === null || params === void 0 ? void 0 : params.methodParams.path.value) && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value)
            ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0]
            : undefined;
        return [
            {
                to: token,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams.amountInMax.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
